import { createContext, useContext, useMemo } from "react";

const Context = createContext({ idPrefix: "", disabled: false });

export function useFieldContext() {
    return useContext(Context);
}

/**
 * @param {Object} props
 * @param {string} props.id
 * @param {boolean} props.disabled
 */
export default function FieldContext({ id = "", disabled, children }) {
    const { idPrefix } = useFieldContext();
    const value = useMemo(() => ({ idPrefix: id ? idPrefix + id + "." : idPrefix, disabled }), [id, disabled]);

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
}